import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import LeadScoreRulesAPI from '../../api/leadScoreRules';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRules(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getRuleById: _state => id => {
    return _state.records.find(rule => rule.id === id);
  },
};

export const actions = {
  fetchRules: async function fetchRules({ commit }) {
    commit(types.SET_LEAD_SCORE_UI_FLAG, { isFetching: true });
    try {
      const response = await LeadScoreRulesAPI.get();
      commit(types.SET_LEAD_SCORE_RULES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_LEAD_SCORE_UI_FLAG, { isFetching: false });
    }
  },

  createRule: async function createRule({ commit }, ruleData) {
    commit(types.SET_LEAD_SCORE_UI_FLAG, { isCreating: true });
    try {
      const response = await LeadScoreRulesAPI.create(ruleData);
      commit(types.ADD_LEAD_SCORE_RULE, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_LEAD_SCORE_UI_FLAG, { isCreating: false });
    }
  },

  updateRule: async function updateRule({ commit }, { id, ...ruleData }) {
    commit(types.SET_LEAD_SCORE_UI_FLAG, { isUpdating: true });
    try {
      const response = await LeadScoreRulesAPI.update(id, ruleData);
      commit(types.EDIT_LEAD_SCORE_RULE, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_LEAD_SCORE_UI_FLAG, { isUpdating: false });
    }
  },

  deleteRule: async function deleteRule({ commit }, id) {
    commit(types.SET_LEAD_SCORE_UI_FLAG, { isDeleting: true });
    try {
      await LeadScoreRulesAPI.delete(id);
      commit(types.DELETE_LEAD_SCORE_RULE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_LEAD_SCORE_UI_FLAG, { isDeleting: false });
    }
  },

  createDefaultRules: async function createDefaultRules({ commit, dispatch }) {
    commit(types.SET_LEAD_SCORE_UI_FLAG, { isCreating: true });
    try {
      await LeadScoreRulesAPI.createDefaults();
      await dispatch('fetchRules');
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_LEAD_SCORE_UI_FLAG, { isCreating: false });
    }
  },
};

export const mutations = {
  [types.SET_LEAD_SCORE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_LEAD_SCORE_RULES]: MutationHelpers.set,
  [types.ADD_LEAD_SCORE_RULE]: MutationHelpers.create,
  [types.EDIT_LEAD_SCORE_RULE]: MutationHelpers.update,
  [types.DELETE_LEAD_SCORE_RULE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
